import { StockItem } from "../../types/stocks";

export interface IPayLaterMtfItem {
  exchId_symbol: string;
  exchange: number;
  token: number;
  nseToken: number;
  bseToken: number;
  symbol: string;
  fullName: string;
  ltp: number;
  prevClose: number;
  logo: string;
  sector: string;
  industry: string;
  mktCapType: string;
  mktCap: number;
  isin: string;
  timeStamp: string;
  formattedSymbol: string;
  listingStatus: string;
  tradeable: boolean;
  updateTimestamp: string;
  changePrice: string | number;
  perChange: string | number;
  stockStatus: "positive" | "negative" | "neutral";
  redirectURL: string;
  perFunding: number;
}

export interface IPayLaterMtfListResponse {
  mtfList: IPayLaterMtfItem[];
  showMore?: boolean;
}

export interface PayLaterMtfStockItem extends StockItem {
  perFunding: number;
}

export const mapMtfItemToStock = (
  item: IPayLaterMtfItem,
): PayLaterMtfStockItem => ({
  changePrice: String(item.changePrice),
  exchange: item.exchange,
  fullName: item.fullName,
  logoURL: item.logo,
  ltp: item.ltp,
  perChange: String(item.perChange),
  redirectURL: item.redirectURL,
  stockStatus: item.stockStatus,
  symbol: item.symbol,
  token: item.token,
  perFunding: item.perFunding,
});
